export const DEFAULT_STATUS_SELECT_OPTION = {
  value: null,
  label: "All",
};
export const STATUS_SELECT_OPTIONS = [
  {
    value: true,
    label: "Active",
  },
  {
    value: false,
    label: "Inactive",
  },
] as const;
export const STATUS_SELECT_FILTER_OPTIONS = [DEFAULT_STATUS_SELECT_OPTION, ...STATUS_SELECT_OPTIONS] as const;

export const DEFAULT_SOURCE_TYPE_OPTION = {
  value: null,
  label: "All",
};
export const SOURCE_TYPE_OPTIONS = [
  {
    value: "RSS feed",
    label: "RSS Feed",
  },
  {
    value: "Content partner",
    label: "Content Partner",
  },
  {
    value: "Twitter account",
    label: "Twitter Account",
  },
  {
    value: "Home page",
    label: "Home Page",
  },
  {
    value: "Earthtime",
    label: "Earthtime",
  },
] as const;
export const SOURCE_TYPE_FILTER_OPTIONS = [DEFAULT_SOURCE_TYPE_OPTION, ...SOURCE_TYPE_OPTIONS] as const;

export const DEFAULT_PUBLICATION_TYPE_OPTION = { value: null, label: "All" };
export const PUBLICATION_TYPE_OPTIONS = [
  { value: "Blogs and Articles", label: "Blogs and Articles" },
  { value: "Reports and Policy Briefs", label: "Reports and Policy Briefs" },
  { value: "Industry Analysis", label: "Industry Analysis" },
  { value: "Case Studies and Capacity Building", label: "Case Studies and Capacity Building" },
  { value: "Guides, Playbooks and Recommendations", label: "Guides, Playbooks and Recommendations" },
  { value: "Data Visualizations", label: "Data Visualizations" },
  { value: "Databases", label: "Databases" },
  { value: "Assessment Tools and Dashboards", label: "Assessment Tools and Dashboards" },
] as const;
export const PUBLICATION_TYPE_FILTER_OPTIONS = [DEFAULT_PUBLICATION_TYPE_OPTION, ...PUBLICATION_TYPE_OPTIONS] as const;

export const DEFAULT_CONTENT_TYPE_OPTION = { value: null, label: "All" };
export const CONTENT_TYPE_OPTIONS = [
  { value: "Articles and Publication", label: "Publications" },
  { value: "Podcasts", label: "Podcasts" },
  { value: "Videos", label: "Videos" },
  { value: "Data Visualizations", label: "Data Visualizations" },
] as const;
export const CONTENT_TYPE_FILTER_OPTIONS = [DEFAULT_CONTENT_TYPE_OPTION, ...CONTENT_TYPE_OPTIONS] as const;

export const DEFAULT_LICENSE_OPTION = { value: null, label: "All" };
export const LICENSE_OPTIONS = [
  { value: "Summary and link through", label: "Summary and Link Through" },
  { value: "Free", label: "Free" },
  { value: "Acknowledgement", label: "Acknowledgement" },
  { value: "Royalty", label: "Royalty" },
  { value: "Other", label: "Other" },
];
export const LICENSE_FILTER_OPTIONS = [DEFAULT_LICENSE_OPTION, ...LICENSE_OPTIONS];

export const AUTOPILOT_OPTIONS = [
  { value: null, label: "Off" },
  { value: "Conservative", label: "Conservative" },
  { value: "Full", label: "Full" },
];

// TODO: Move the Country, Region and Greater Region data to BE in the future
export const COUNTRY_VALUES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antartica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "Christmas Islands",
  "Cocos (Kelling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic People's Republic of Korea",
  "Democratic Republic of Congo",
  "Denmark",
  "Djibouti",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falklands Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "Former Yugoslav Republic of Macedonia",
  "France",
  "France, Metropolitan",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard and Mc Donald Islands",
  "Honduras",
  "Hong Kong SAR",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iraq",
  "Ireland",
  "Islamic Republic of Iran",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyz Republic",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao SAR",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Islands",
  "Northern Cyprus",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territories",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "People's Republic of China",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of Korea",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "Somaliland",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "St. Helena",
  "St. Pierre and Miquelon",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen Islands",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan, China",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States Minor Outlying Islands",
  "Unknown",
  "Uruguay",
  "USA",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City State",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna Islands",
  "Yemen",
  "Zambia",
  "Zimbabwe",
] as const;

export type CountryValue = (typeof COUNTRY_VALUES)[number];

export const COUNTRY_OPTIONS = COUNTRY_VALUES.map((value) => ({ value, label: value })) as readonly {
  readonly value: CountryValue;
  readonly label: CountryValue;
}[];

export const REGION_VALUES = [
  "South Asia",
  "Central/Eastern Europe",
  "North Africa",
  "Asia Pacific",
  "Western Europe",
  "Sub-saharan Africa",
  "Antarctica",
  "Australasia",
  "Middle East",
  "Greater China",
  "Japan",
  "North America",
  "Latin America",
  "Russia",
  "Unknown",
] as const;

export type RegionValue = (typeof REGION_VALUES)[number];

export const REGION_OPTIONS = REGION_VALUES.map((value) => ({ label: value, value })) as readonly {
  readonly label: RegionValue;
  readonly value: RegionValue;
}[];

export const GREATER_REGION_VALUES = [
  "Asia",
  "Europe",
  "Middle East/North Africa",
  "North America",
  "Latin America",
  "Unknown",
] as const;

export type GreaterRegionValue = (typeof GREATER_REGION_VALUES)[number];

export const GREATER_REGION_OPTIONS = GREATER_REGION_VALUES.map((value) => ({ label: value, value })) as readonly {
  readonly label: GreaterRegionValue;
  readonly value: GreaterRegionValue;
}[];
